import { Dispatch, SetStateAction, useState } from "react";

import Paper from "@mui/material/Paper";
import { CSSObject } from "@mui/material/styles";
import Typography from "@mui/material/Typography";

import { colors } from "@dotnet/telematics-design-system";

import { selectableImageType } from "../..";
import { inputFieldMarginBottom } from "../../../../../../shared";
import RectangleLoader from "../../../../../../shared/components/loaders/RectangleLoader";
import SelectImageDialog from "../../Dialogs/SelectImageDialog/SelectImageDialog";
import { useStyles } from "../../styles";
import ImageDropzoneContent from "./ImageDropzoneContent";

interface ImageDropzoneProps {
  label: string;
  setSelectedImage: Dispatch<SetStateAction<selectableImageType | null>>;
  selectedImage: selectableImageType | null;
  setIsInteracted?: Dispatch<SetStateAction<boolean>>;
  isLoading?: boolean;
  disabled?: boolean;
}

const ImageDropzone = ({
  label,
  setSelectedImage,
  selectedImage,
  setIsInteracted,
  isLoading,
  disabled
}: ImageDropzoneProps) => {
  const [isSelectImageDialogOpen, setIsSelectImageDialogOpen] =
    useState<boolean>(false);

  const { imageDropzone } = useStyles();

  const handleSelectImageButtonClick = () => {
    setIsSelectImageDialogOpen(true);
  };

  const handleCloseSelectImageDialog = () => {
    setIsSelectImageDialogOpen(false);
  };

  return (
    <>
      {isLoading ? (
        <RectangleLoader
          width={"100%"}
          height={"92px"}
          customStyle={inputFieldMarginBottom}
          testId="image-dropzone-loader"
        />
      ) : (
        <>
          <Typography
            variant="body2Medium"
            sx={{ marginBottom: "4px" }}
            component="div"
          >
            {label}
          </Typography>
          <Paper
            data-testid="image-dropzone"
            elevation={0}
            variant="outlined"
            sx={
              [
                imageDropzone,
                inputFieldMarginBottom,
                { backgroundColor: disabled ? colors.gray100 : "unset" }
              ] as CSSObject[]
            }
          >
            <ImageDropzoneContent
              onButtonClick={handleSelectImageButtonClick}
              selectedImage={selectedImage}
              disabled={disabled}
            />
          </Paper>

          <SelectImageDialog
            isDialogOpen={isSelectImageDialogOpen}
            onDialogClose={handleCloseSelectImageDialog}
            setSelectedImage={setSelectedImage}
            selectedImage={selectedImage}
            setIsInteracted={setIsInteracted}
          />
        </>
      )}
    </>
  );
};

export default ImageDropzone;
